export default {"src":"/_next/static/media/hero-illustration-enery.e621abc5.svg","height":120,"width":120};